export default class UnreachableCaseError extends Error {
  constructor(val?: never) {
    super(`Unreachable case: ${val}.`);
  }
}
